import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

export class RouteMapper {
    static findParamRecursively(route: ActivatedRouteSnapshot, paramName: string): string | null {
        const paramValue = route.paramMap.get(paramName);
        if (paramValue) {
            return paramValue;
        } else {
            if (route.children && route.children.length) {
                return this.findParamRecursively(route.children[0], paramName);
            } else {
                return null;
            }
        }
    }

    static findParamRecursivelyFromRoute(route: ActivatedRoute, paramName: string): string | null {
        const snapshot = route.snapshot;
        const paramValue = snapshot.paramMap.get(paramName);
        if (paramValue) {
            return paramValue;
        } else {
            if (route.children && route.children.length) {
                return this.findParamRecursivelyFromRoute(route.children[0], paramName);
            } else {
                return null;
            }
        }
    }

    static findDataRecursivelyFromRoute(route: ActivatedRoute, dataKey: string): string | null {
        const snapshot = route.snapshot;
        const paramValue = snapshot.data[dataKey];
        if (paramValue) {
            return paramValue;
        } else {
            if (route.children && route.children.length) {
                return this.findDataRecursivelyFromRoute(route.children[0], dataKey);
            } else {
                return null;
            }
        }
    }
}
